(function ($) {
    $(() => {

    let recipeImagesContainer = $('.section-recipe .images');

    if (recipeImagesContainer.length > 0) {
        recipeImagesContainer.masonry({
            itemSelector: '.item'
        });

        $(document).ready(function() {
           setTimeout(() => {
                recipeImagesContainer.masonry( 'layout' ); 
           }, 500); 
        });
    }

    if ($('.section-recipe-print').length > 0) {
        window.print();
    }

    $('.slider-recommended-wines').slick({
        infinite: true,
        arrows: true,
        dots: false,
        slidesToShow: 3,
        prevArrow: $('.btn-recommended-wines-left'),
        nextArrow: $('.btn-recommended-wines-right'),
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2.3,
                    infinite: false,
                    arrows: false
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1.2,
                    infinite: false,
                    arrows: false
                }
            },
        ]
    });

    });
})(jQuery);